import Grid from '@mui/material/GridLegacy';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import React from 'react';
import dot from '../../assets/webp/fromPNG/dot-bg.webp';
import { RichTextGlobal } from '../RichText/global';
import type { BlockProps } from './Block.types';

const PREFIX = 'Block';

const classes = {
  root: `${PREFIX}-root`,
  item: `${PREFIX}Item`,
  backgroundColor: `${PREFIX}BackgroundColor`,
};

const StyledGrid = styled(Grid)<BlockProps>(({ theme, block }) => ({
  [`&.${classes.root}`]: {
    '& ul': {
      padding: 0,
    },
    '& li': {
      padding: theme.spacing(1),
      '&:before': {
        width: 16,
        height: 16,
        top: '50%',
        transform: 'translateY(15%)',
        background: `url(${dot})`,
      },
    },
  },

  [`&.${classes.item}`]: () => {
    const backgroundImage = block?.backgroundImage;
    if (!backgroundImage) {
      return {
        zIndex: 2,
        [theme.breakpoints.down('lg')]: {
          textAlign: 'center',
        },
      };
    }
    return {
      position: 'relative',
      zIndex: 1,
      [theme.breakpoints.up('md')]: {
        '&:after': {
          content: "''",
          position: 'absolute',
          width: '100vw',
          height: `${backgroundImage?.height}%`,
          background: `url(${backgroundImage?.image?.url})`,
          backgroundPositionX: backgroundImage?.align,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'auto 100%',
          backgroundPositionY: '0',
          [backgroundImage?.align || '']: `${backgroundImage?.left}%`,
          top: `${backgroundImage?.top}${
            backgroundImage?.topUnit === 'percentage' ? '%' : 'px'
          }`,
          zIndex: -1,
        },
        '& > div': {
          position: 'relative',
          zIndex: 1,
        },
      },
      [theme.breakpoints.down('lg')]: {
        textAlign: 'center',
      },
    };
  },

  [`&.${classes.backgroundColor}`]: () => {
    if (!block?.backgroundColor) return {};
    return {
      paddingBottom: '0 !important',
      marginBottom: '40px',
      backgroundColor: block?.backgroundColor,
      borderRadius: block?.backgroundRadius,
    };
  },
}));

export const Block: React.FC<BlockProps> = ({ block }) => {
  return (
    <StyledGrid
      block={block}
      item
      xs={block?.xs}
      sm={block?.sm}
      md={block?.md}
      className={clsx(classes.backgroundColor, classes.item, classes.root)}>
      <RichTextGlobal
        content={block?.content || ''}
        embeddedItems={block?.embeddedInRichText}
      />
    </StyledGrid>
  );
};
